import React from 'react';

interface ButtonProps{
    text?: string;
    className?: string;
    onClickBtn?: any;
}

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
    return(
        <div className={`${props.className} comment-btn`} onClick={() => { props.onClickBtn && props.onClickBtn();}}> 
            <div className='btn-anger' style={{fontSize: '20px', height: '100%'}}>
                {props.text}
            </div>
        </div>
    );
}

export default Button;